// Copyright (c) 2024. UpCircle Technology AG.
// All rights reserved. Redistribution in source and/or binary forms,
// with or without modification, is not permitted.

// Helper function to check if there are any valid values from a given index onwards
function hasValidValuesAhead(data, startIndex, lookAhead) {
    for (let j = startIndex; j < Math.min(startIndex + lookAhead, data.length); j++) {
        const value = data[j]?.y;
        if (value !== null && value !== undefined && !isNaN(value)) {
            return true;
        }
    }
    return false;
}

// Function to calculate Exponential Moving Average
export function calculateEMA(data, period = 12, lookAhead = 12, repeatLastValue = false) {
    if (!data || data.length === 0) return [];
    
    const emaData = [];
    const multiplier = 2 / (period + 1);
    let lastValidEMA = null;
    
    for (let i = 0; i < data.length; i++) {
        let currentValue = data[i]?.y;
        
        // If current value is null/undefined, keep the gap in the timeline
        if (currentValue === null || currentValue === undefined || isNaN(currentValue)) {
            if (hasValidValuesAhead(data, i, lookAhead) && lastValidEMA !== null) {
                if (repeatLastValue) {
                    currentValue = lastValidEMA;
                } else {
                    currentValue = 0;
                }
            } else {
                emaData[i] = {
                    x: data[i].x,
                    y: null
                };
                lastValidEMA = null;
                continue;
            }
        }
        
        // For the first valid value, use it as the initial EMA
        if (lastValidEMA === null) {
            lastValidEMA = currentValue;
            emaData[i] = {
                x: data[i].x,
                y: lastValidEMA
            };
            continue;
        }
        
        // Calculate EMA using the last valid EMA value
        lastValidEMA = (currentValue * multiplier) + (lastValidEMA * (1 - multiplier));
        emaData[i] = {
            x: data[i].x,
            y: lastValidEMA
        };
    }
    
    return emaData;
}